import z from "zod";

export const TopUpSchema = z.object({
  amount: z
    .number("Required")
    .positive("Top-up amount must be greater than 0")
    .max(1000, "Top-up amount cannot be more than 1,000"),
  currency: z.string().min(1, "Required"),
  reason: z
    .string()
    .min(1, "Please provide a reason for the top-up")
    .max(250, "Top-up reason must not exceed 250 characters")
    .trim(),
});

export type TopUpFormValues = z.infer<typeof TopUpSchema>;

export const ApproveTopUpSchema = (maxAmount: number, currency = "") =>
  z.object({
    approvedAmount: z
      .number()
      .gt(0, "Amount must be greater than 0")
      .max(
        maxAmount,
        `Amount cannot exceed requested ${maxAmount} ${currency}`.trim()
      ),
  });

export type ApproveTopUpFormValues = z.infer<
  ReturnType<typeof ApproveTopUpSchema>
>;
